import { memo } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { CALENDAR_Z_INDICES } from '../constants';
import { useCalendarGridStore } from '../store/calendar-grid.store';
import { useZoomStore } from '../store/zoom.store';
import { getEffectiveTimeIndicatorLines, getHourLabels } from '../utils';

export const TimeColumn = memo(() => {
  const timeIndicatorLines = useCalendarGridStore((s) => s.timeIndicatorLines);
  const pxPerMinute = useZoomStore((s) => s.pxPerMinute);
  const effectiveTimeIndicatorLines = getEffectiveTimeIndicatorLines(timeIndicatorLines, pxPerMinute);
  const labels = getHourLabels(effectiveTimeIndicatorLines);

  return (
    <div data-time-column css={containerStyle}>
      {labels.map((label) => (
        <Text key={label} size='small' color={label.includes(':30') ? 'subdued' : 'light'} css={textStyle}>
          {label}
        </Text>
      ))}
    </div>
  );
});

TimeColumn.displayName = 'TimeColumn';

const containerStyle = css({
  gridRow: '4 / -2', // Start from the fourth row to skip the header, all-day, and spacer rows
  gridColumn: 1,
  display: 'grid',
  textAlign: 'right',
  position: 'sticky',
  left: 0,
  zIndex: CALENDAR_Z_INDICES.timeColumn,
  backgroundColor: theme.colors.neutral5,
});

const textStyle = css({
  paddingRight: theme.spacing(0.5),
  marginTop: theme.spacing(-1),
  userSelect: 'none',
});
